module.exports = __webpack_public_path__ + "static/media/drawStop.96f7c171.mp3";